import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGetCareNow } from '~/components/CareTeam/hooks/useGetCareNow';
import { analyticsTrackEvent } from '~/core/analytics';
import { DRAWER_TYPE_URGENT_CARE, NAV_TILE_CLICKED } from '~/core/analytics/events';
import { isUserProfileAMinor } from '~/core/util/userProfile';
import useSelectActiveUserProfile from '~/hooks/useSelectActiveUserProfile';
import dataTestIds from '~/test/test-ids';
import { useTrackNavTile } from '../../hooks/useTrackNavTile';
import { Details, Icon, Root, SubTitle, Title } from '../../styles';

const BookUrgentCare = () => {
  const goToGetCare = useGetCareNow('uc');

  const onClick = () => {
    goToGetCare();
    analyticsTrackEvent(NAV_TILE_CLICKED, {
      type: DRAWER_TYPE_URGENT_CARE,
    });
  };

  useTrackNavTile('urgent-care');

  const { t } = useTranslation(['account']);

  const isMinor = isUserProfileAMinor(useSelectActiveUserProfile());

  return (
    <Root onClick={onClick}>
      <Icon alt="Illustration of an urgent care clinic" src="/images/account/tiles/uc-new.svg" />
      <Details data-testid={dataTestIds.account.urgentCareNavTile}>
        <Title>{t(isMinor ? 'account:navTiles.kids.uc.title' : 'account:navTiles.uc.title')}</Title>
        <SubTitle>
          {t(isMinor ? 'account:navTiles.kids.uc.subtitle' : 'account:navTiles.uc.subtitle')}
        </SubTitle>
      </Details>
    </Root>
  );
};

export default BookUrgentCare;
